export default {
  NATIVE_SIGN_OUT_MSG: {
    event: 'signOut',
  },
  SOCURE_DOWN_MSG: {
    event: 'socureDown',
  },
  PRINT_SCREEN_MSG: {
    event: 'printScreen',
  },
  DMV_COMPLETION_MSG: {
    event: 'dmvCompleted',
    status: 'success',
  },
  DMV_IDLE_WARNING_MSG: {
    event: 'dmvIdleWarning',
  },
  DMV_FLOW_STARTED_MSG: {
    event: 'dmvFlowStarted',
  },
  DMV_FLOW_ENDED_MSG: {
    event: 'dmvFlowEnded',
  },
  CARD_TYPES: {
    VISA: 'VISA',
    DISCOVER: 'DISC',
    AMEX: 'AMEX',
    MC: 'MC',
  },
  AGENCY_PAYMENT_URLS: [
    '/dmvrr/payment',
    '/dpslr/payment',
    '/tdlrlr/payment',
    '/tpwdas/payment',
  ],
  // Socure Device Risk SDK Key Names
  SOCURE_ACCOUNT_CREATION_KEY_NAME: 'Texas.gov_TxT_accountcreation',
  SOCURE_OOS_KEY_NAME: 'Texas.gov_TxT_NoDLID_AccountCreation',
  DLID_MAX_SCAN_ATTEMPTS: 5,
};
